import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const mergeMainIntoBranchSchema = z.object({
  branchId: z.string(),
});

export const mergeMainIntoBranch = mutator({
  schema: mergeMainIntoBranchSchema,
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ args: { branch } }) => {
    if (!branch.headCommitId)
      throw userFacingError("Branch has no head commit");
    if (!branch.forkCommitId) throw userFacingError("Branch has no fork point");
  },
});
